"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.config = void 0;

var _utils = require("../../../../utils");

var color = function (code) {
  if (code === void 0) {
    code = '';
  }

  code = code.toLowerCase().replace(/\s/, '-');

  switch (code) {
    case 'out_of_service':
      return '#535353';

    case 'obs_not_current':
      return '#afb6ad';

    case 'not_defined':
      return '#5f9de6';

    case 'low_threshold':
      return '#7e5012';

    case 'no_flooding':
      return '#0cff01';

    case 'action':
      return '#ffff02';

    case 'minor':
      return '#ff8700';

    case 'moderate':
      return '#ff0000';

    case 'major':
      return '#c000ff';

    default:
      return '#000000';
  }
};
/**
 * @private
*/


var config = {
  data: {
    request: {
      endpoint: 'rivers'
    },
    properties: {
      id: 'id',
      timestamp: 'ob.timestamp'
    }
  },
  style: {
    marker: function (data) {
      var type = (0, _utils.get)(data, 'ob.status');
      return {
        className: 'marker-river',
        svg: {
          shape: {
            type: 'circle',
            fill: {
              color: color(type)
            },
            stroke: {
              color: '#ffffff',
              width: 2
            }
          }
        },
        size: [14, 14]
      };
    }
  }
};
exports.config = config;
var _default = config;
exports.default = _default;